"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrintableGreenwayIcon = PrintableGreenwayIcon;
var _renderer = require("@react-pdf/renderer");
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function PrintableGreenwayIcon({
  color,
  ...props
}) {
  return /*#__PURE__*/_react.default.createElement(_renderer.Svg, _extends({
    viewBox: "0.5 0 32 32"
  }, props), /*#__PURE__*/_react.default.createElement(_renderer.Path, {
    d: "M16 0c-8.822 0-16 7.18-16 16.002s7.178 15.998 16 15.998 16-7.176 16-15.998-7.178-16.002-16-16.002zM16 30.56c-8.030 0-14.56-6.532-14.56-14.558 0-8.030 6.532-14.56 14.56-14.56s14.56 6.532 14.56 14.56c0 8.028-6.53 14.558-14.56 14.558zM22.044 12.92c0.284-0.5 0.448-1.076 0.448-1.694 0-1.74-1.294-3.174-2.974-3.398-0.712-1.144-1.976-1.91-3.426-1.91-1.448 0-2.712 0.766-3.426 1.91-1.678 0.224-2.974 1.658-2.974 3.398 0 0.618 0.164 1.194 0.45 1.694-1.028 0.594-1.722 1.7-1.722 2.97 0 1.894 1.536 3.434 3.432 3.434 0.268 0 0.448-0.036 0.698-0.094 0.498 0.834 1.188 1.472 2.146 1.776v4.874h2.878v-4.902c0.958-0.31 1.58-0.936 2.064-1.746 0.25 0.058 0.468 0.094 0.738 0.094 1.894 0 3.41-1.54 3.41-3.434 0.002-1.272-0.716-2.378-1.742-2.972z",
    fill: color
  }));
}